import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, roles = [] }) => {
  const { user, hasRole, loading } = useAuth();

  // Если контекст ещё загружается — ждём
  if (loading) {
    return <div style={{ textAlign: 'center', padding: 40 }}>Загрузка...</div>;
  }

  // Проверяем токен в localStorage (защита от race condition при навигации после login)
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  if (!user && !token) {
    return <Navigate to="/login" replace />;
  }

  if (roles.length > 0 && user && !hasRole(roles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Пользователь авторизован по токену в localStorage, но user ещё не загрузился
  if (!user && token) {
    return <div style={{ textAlign: 'center', padding: 40 }}>Загрузка...</div>;
  }

  return children;
};

export default ProtectedRoute;
